import Flickity from 'flickity';

export function testimonialCarousel() {
	Array.from(document.querySelectorAll('.js-testimonials')).forEach(elem => {
		let itemsEl = elem.querySelector('.js-testimonials-items');
		let controlsEl = elem.querySelector('.js-testimonials-controls');

		if (!itemsEl) {
			return;
		}

		let carousel = new Flickity(itemsEl, {
			pageDots: false,
			fade: true,
			wrapAround: true,
			adaptiveHeight: false,
		});

		controlsEl.append(carousel.prevButton.element);
		controlsEl.append(carousel.nextButton.element);
	});
}
